import Image from 'next/image';
import Link from 'next/link';

export default function Contact() {
  return (
    <div className="min-h-screen bg-[#F6EFED]">
      {/* Hero Section - Same as Homepage */}
      <section className="relative min-h-[720px] flex items-center">
        {/* Background Image/Video */}
        <div className="absolute inset-0">
          <Image
            src="/hero-banner.jpg"
            alt="Women working out in gym"
            fill
            className="object-cover"
            priority
          />
          {/* Dark overlay */}
          <div className="absolute inset-0 bg-[#45394B]/60" />
        </div>

        {/* Header - Same as Homepage */}
        <header className="absolute top-0 left-0 right-0 z-50">
          <div className="absolute inset-0 bg-transparent" />
          
          <div className="relative max-w-[1920px] mx-auto px-[80px] py-[40px]">
            <div className="flex items-center justify-between">
              {/* Logo */}
              <Link href="/" className="flex items-center" style={{ width: '367.62px', height: '94px' }}>
                <Image
                  src="/header-transparent-logo.png"
                  alt="Female Fitness Finder"
                  width={367.62}
                  height={94}
                  className="object-contain"
                  priority
                />
              </Link>

              {/* Navigation */}
              <nav className="hidden md:flex items-center gap-[40px]">
                <Link href="/" className="font-['Archivo',sans-serif] text-[18px] text-white font-normal leading-[100%] tracking-[0%]">Home</Link>
                <Link href="/about" className="font-['Archivo',sans-serif] text-[18px] text-white font-normal leading-[100%] tracking-[0%]">About</Link>
                <Link href="/directory" className="font-['Archivo',sans-serif] text-[18px] text-white font-normal leading-[100%] tracking-[0%]">Directory</Link>
                <Link href="/for-women" className="font-['Archivo',sans-serif] text-[18px] text-white font-normal leading-[100%] tracking-[0%]">For Women</Link>
                <Link href="/contact" className="font-['Archivo',sans-serif] text-[18px] text-white font-normal leading-[100%] tracking-[0%]">Contact</Link>
              </nav>

              {/* Right side actions */}
              <div className="flex items-center gap-[40px]">
                <div className="w-4 h-4">
                  <Image
                    src="/search-icon.svg"
                    alt="Search"
                    width={16}
                    height={16}
                    className="object-contain"
                  />
                </div>
                <button className="px-[20px] py-[9px] bg-[#8a7490] text-white font-['Archivo',sans-serif] text-[14px] font-medium rounded-[5px] hover:bg-[#7a647d] transition-colors flex items-center gap-[6px]">
                  Register
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                <Link href="/login" className="font-['Archivo',sans-serif] text-[14px] text-white font-normal leading-[100%] tracking-[0%]">Login</Link>
              </div>
            </div>
          </div>
        </header>

        {/* Hero Content */}
        <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 pt-24">
          <div className="max-w-2xl">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
              Contact Us
            </h1>
            <p className="text-lg text-white/90 mb-8 max-w-xl">
              Get in touch with our team to learn more about Female Fitness Finder and how we can help you find the perfect women-only fitness space.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Left Side - Image with Contact Info */}
          <div className="relative">
            <div className="relative h-[500px] rounded-[24px] overflow-hidden">
              <Image
                src="/contact-woman.jpg"
                alt="Woman with kettlebells"
                fill
                className="object-cover"
              />
            </div>
            {/* Contact Info Overlay */}
            <div className="absolute bottom-6 left-6 right-6 bg-[#625564]/90 backdrop-blur-sm rounded-[16px] p-4">
              <div className="grid grid-cols-2 gap-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs text-white/70">Phone Number</p>
                    <p className="text-sm text-white font-medium">+44 123 456 7890</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs text-white/70">Email Address</p>
                    <p className="text-sm text-white font-medium">info@femalefitnessfinder.co.uk</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Form */}
          <div>
            <p className="text-sm text-[#8a7490] mb-2">Contact Us</p>
            <h2 className="text-3xl font-bold text-[#2b262e] mb-4">Get in Touch</h2>
            <p className="text-[#6e6672] mb-8 text-sm leading-relaxed">
              It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.
            </p>

            <form className="space-y-5">
              {/* First Row - Name Fields */}
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="firstName" className="block text-xs font-medium text-[#6e6672] mb-2">
                    First Name <span className="text-[#8a7490]">*</span>
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    className="w-full px-4 py-3 bg-white border border-[#e8e1e6] rounded-xl text-[#2b262e] text-sm placeholder:text-[#a0969e] outline-none focus:ring-2 focus:ring-[#8a7490] focus:border-transparent transition-all"
                    placeholder="e.g. John"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="lastName" className="block text-xs font-medium text-[#6e6672] mb-2">
                    Last Name <span className="text-[#8a7490]">*</span>
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    className="w-full px-4 py-3 bg-white border border-[#e8e1e6] rounded-xl text-[#2b262e] text-sm placeholder:text-[#a0969e] outline-none focus:ring-2 focus:ring-[#8a7490] focus:border-transparent transition-all"
                    placeholder="e.g. Doe"
                    required
                  />
                </div>
              </div>

              {/* Second Row - Email and Phone */}
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="email" className="block text-xs font-medium text-[#6e6672] mb-2">
                    Email Address <span className="text-[#8a7490]">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="w-full px-4 py-3 bg-white border border-[#e8e1e6] rounded-xl text-[#2b262e] text-sm placeholder:text-[#a0969e] outline-none focus:ring-2 focus:ring-[#8a7490] focus:border-transparent transition-all"
                    placeholder="e.g. johndoe@example.com"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-xs font-medium text-[#6e6672] mb-2">
                    Phone Number <span className="text-[#8a7490]">*</span>
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="w-full px-4 py-3 bg-white border border-[#e8e1e6] rounded-xl text-[#2b262e] text-sm placeholder:text-[#a0969e] outline-none focus:ring-2 focus:ring-[#8a7490] focus:border-transparent transition-all"
                    placeholder="000 000 0000"
                    required
                  />
                </div>
              </div>

              {/* Message Field */}
              <div>
                <label htmlFor="message" className="block text-xs font-medium text-[#6e6672] mb-2">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={4}
                  className="w-full px-4 py-3 bg-white border border-[#e8e1e6] rounded-xl text-[#2b262e] text-sm placeholder:text-[#a0969e] outline-none focus:ring-2 focus:ring-[#8a7490] focus:border-transparent transition-all resize-none"
                  placeholder="Type your message here..."
                ></textarea>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="px-6 py-3 bg-[#8a7490] text-white text-sm font-medium rounded-xl hover:bg-[#7a647d] transition-colors inline-flex items-center gap-2"
              >
                Submit Message
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </button>
            </form>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#625564] text-white">
        <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {/* Top Row */}
          <div className="flex flex-col lg:flex-row justify-between items-start gap-8 mb-10">
            {/* Logo and tagline */}
            <div>
              <div className="flex items-center gap-2 mb-2">
                <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                  <span className="text-white font-bold text-xl">F</span>
                </div>
                <div className="flex flex-col">
                  <span className="font-bold text-xl text-white">
                    Female Fitness
                  </span>
                  <span className="text-[10px] tracking-[0.2em] text-white/70 uppercase">
                    Finder
                  </span>
                </div>
              </div>
              <p className="text-sm text-white/60 mt-2">
                Finding female-led fitness, for you
              </p>
            </div>

            {/* Contact Info */}
            <div className="flex flex-wrap gap-8">
              <div className="flex items-center gap-2 text-sm text-white/80">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                </svg>
                <span>+44 750 753 5943</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-white/80">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
                <span>tia@femalefitnessfinder.com</span>
              </div>
              {/* Social Icons */}
              <div className="flex items-center gap-4">
                <a href="#" className="text-white/80 hover:text-white transition-colors">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a href="#" className="text-white/80 hover:text-white transition-colors">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1112.324 0 6.162 6.162 0 01-12.324 0zM12 16a4 4 0 110-8 4 4 0 010 8zm4.965-10.405a1.44 1.44 0 112.881.001 1.44 1.44 0 01-2.881-.001z"/>
                  </svg>
                </a>
                <a href="#" className="text-white/80 hover:text-white transition-colors">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* Navigation Row */}
          <div className="border-t border-white/20 pt-8 mb-8">
            <nav className="flex flex-wrap justify-between items-center">
              <Link href="/" className="text-sm text-white/80 hover:text-white transition-colors">Home</Link>
              <Link href="/about" className="text-sm text-white/80 hover:text-white transition-colors">About</Link>
              <Link href="/discovery" className="text-sm text-white/80 hover:text-white transition-colors">Directory</Link>
              <Link href="/for-women" className="text-sm text-white/80 hover:text-white transition-colors">For Women</Link>
              <Link href="/contact" className="text-sm text-white/80 hover:text-white transition-colors">Contact</Link>
            </nav>
          </div>

          {/* Bottom Row */}
          <div className="border-t border-white/20 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-white/60">
              Copyright © 2026 <span className="text-[#8a7490]">Female Fitness Finder</span>. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link href="/privacy" className="text-xs text-white/60 hover:text-white transition-colors">Privacy Policy</Link>
              <Link href="/terms" className="text-xs text-white/60 hover:text-white transition-colors">Terms & Conditions</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
